<section class="section white-100 unified-section" *ngIf="unifiedSolutionsData">
  <div class="section-container">
    <h2 class="section-heading mar-b-32 align-c">
      <span [innerHTML]="highlightedTextUnified || unifiedSolutionsData?.header"></span>
    </h2>
    <div
      class="section-description mar-b-48 align-c"
      *ngIf="unifiedSolutionsData?.description"
    >
      <div
        class="wid-75"
        [innerHtml]="unifiedSolutionsData?.description | toHtml"
      ></div>
    </div>
    <div class="section-product-landing">
      <div class="product-landing" *ngFor="let card of unifiedSolutionsData?.cards">
        <a [href]="card?.fields?.link || 'javascript:void(0)'" class="card-link">
          <div class="product-landing-content">
            <h5 class="product-landing-heading">
              {{ card?.fields?.title || card?.fields?.richTextTitle?.content?.[0]?.content?.[0]?.value }}
              <img
                *ngIf="card?.fields?.button?.[0]?.fields?.icon?.fields?.file?.url"
                fetchpriority="low"
                loading="lazy"
                class="mar-l-8 heading-link-arrow-icon"
                alt="arrow"
                [src]="card?.fields?.button?.[0]?.fields?.icon?.fields?.file?.url"
              />
            </h5>
            <div
              class="product-landing-description"
              [innerHtml]="card?.fields?.description | toHtml"
            ></div>
          </div>
          <figure class="align-c" *ngIf="card?.fields?.imageicon?.fields?.file?.url">
            <img
              fetchpriority="low"
              loading="lazy"
              [src]="card?.fields?.imageicon?.fields?.file?.url"
              [alt]="card?.fields?.title || 'visual'"
              class="product-landing-img"
            />
          </figure>
        </a>
      </div>
    </div>
  </div>
</section>